import { render, staticRenderFns } from "./HistoryDoctorMasseuse.vue?vue&type=template&id=7b8d4d54&scoped=true&"
import script from "./HistoryDoctorMasseuse.vue?vue&type=script&lang=js&"
export * from "./HistoryDoctorMasseuse.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDoctorMasseuse.vue?vue&type=style&index=0&id=7b8d4d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d4d54",
  null
  
)

export default component.exports